import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../../shared/interfaces/api-response.interface';

export interface UserLoginResponse {
    sessionId?: string;
    trxId?: string;
    authCode?: string;
    selectedRole?: string;
    userProfile?: {
        employName?: string | null;
        sub?: string;
        emailVerified?: boolean;
        memberNumber?: string | null;
        policyNumber?: string | null;
        username?: string;
        userEmail?: string;
        userPhoneNumber?: string;
        userType?: string | null;
        clientNumber?: string | null;
        subNumber?: string | null;
        selectedRole?: string | null;
    };
}

export interface UserOTPResponse {
    authCode?: string;
    selectedRole?: string;
    userProfile?: {
        employName?: string | null;
        sub?: string;
        emailVerified?: boolean;
        memberNumber?: string | null;
        policyNumber?: string | null;
        username?: string;
        userEmail?: string;
        userPhoneNumber?: string;
        userType?: string | null;
        clientNumber?: string | null;
        subNumber?: string | null;
        selectedRole?: string | null;
    };
}

@Injectable({
    providedIn: 'root'
})
export class UserAuthService {
    private readonly userAuthPath = environment.SALESFORCE_AUTH;
    
    constructor(private readonly http: HttpClient) {}

    private getHeaders(includeAuth: boolean = false): HttpHeaders {
        const headers: any = {
            'Content-Type': 'application/json',
            'X-Language': 'IDN'
        };

        if (includeAuth) {
            const token = localStorage.getItem('access_token');
            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }
        }

        return new HttpHeaders(headers);
    }

    validateCredentials(username: string, password: string): Observable<ApiResponse<UserLoginResponse>> {
        const url = `${this.userAuthPath.baseUrl}${this.userAuthPath.userLoginPath}/validate-credentials`;
        const body = {
            username,
            password,
            portalId: 'user'
        };

        return this.http.post<ApiResponse<UserLoginResponse>>(url, body, {
            headers: this.getHeaders()
        });
    }

    submitOTP(sessionId: string, otp: string, trxId: string): Observable<ApiResponse<UserOTPResponse>> {
        const url = `${this.userAuthPath.baseUrl}${this.userAuthPath.userLoginPath}/submit-otp`;
        const body = {
            sessionId,
            otp,
            trxId
        };

        return this.http.post<ApiResponse<UserOTPResponse>>(url, body, {
            headers: this.getHeaders()
        });
    }

    resendOTP(sessionId: string, sendOtpType: 'wab' | 'email' = 'wab'): Observable<ApiResponse<any>> {
        const url = `${this.userAuthPath.baseUrl}${this.userAuthPath.userLoginPath}/resend-otp`;
        const body = {
            sessionId,
            sendOtpType
        };

        return this.http.post<ApiResponse<any>>(url, body, {
            headers: this.getHeaders()
        });
    }
}